<script setup lang="ts">
import { onMounted } from 'vue';

import {
  IDialog,
  WsDialogSection,
  WsDialogActions,
  WsButton,
} from '@mfl/common-components';
import {
  trackEvent,
  PURCHASE_PLANS_URL,
  reportUserAnalyticEvent,
} from '@mfl/platform-shell';
import { navigateTo } from '@mfl/framework';

import { openScheduleDemo } from './open-schedule-demo';
import strings from './upgrade.strings';

const props = defineProps<{
  dialog: IDialog<'invite' | 'edit'>;
}>();

const message =
  props.dialog.input === 'invite'
    ? strings.upgradeDialogTextInvite
    : strings.upgradeDialogTextEdit;

async function openScheduleDemoModal() {
  await openScheduleDemo('account-settings-users');
}

function redirectToUpgrade() {
  try {
    // prevent an error with the analytics from holding the back the user from redirecting to upgrade
    sendEvent('team_upgrade_modal_user_clicked_upgrade');
  } catch (e) {
    console.error(e);
  }
  reportUserAnalyticEvent({
    eventName: 'navigated_to_pricing_page',
    metadata: { origin: 'account_settings_upgrade_dialog' },
  });
  redirectTo(`${PURCHASE_PLANS_URL}`);
}

function redirectTo(path: string) {
  navigateTo(path, { reload: true });
}

function sendEvent(eventName: string) {
  trackEvent({
    eventName,
    eventMetadata: {
      attributes: {
        page: 'account-settings/users',
      },
    },
  });
}

onMounted(() => {
  try {
    sendEvent('team_upgrade_modal_show');
  } catch (e) {
    console.error(e);
  }
});
</script>

<template>
  <div class="upgrade-dialog">
    <WsDialogSection>
      {{ message }}
    </WsDialogSection>
    <WsDialogActions>
      <WsButton
        :label="strings.scheduleADemo"
        variant="outlined"
        aid="ACCOUNT_SETTINGS_UPGRADE_DIALOG_DEMO"
        @click="openScheduleDemoModal"
      />
      <WsButton
        :label="strings.upgrade"
        aid="ACCOUNT_SETTINGS_UPGRADE_DIALOG_UPGRADE"
        @click="redirectToUpgrade"
      />
    </WsDialogActions>
  </div>
</template>

<style lang="scss" scoped>
.upgrade-dialog {
  width: 400px;
}
</style>
